import { env } from "./config";

export default function Fetcher ( call, feed, verbose = false ) {

  let _feed = null;

  // insert accedd tokens to call object
  let _call = call;


  _feed = env.api.endpoint[feed];
  return new Promise ( ( resolve, reject ) => {
    // console.log( _call );

    // build form data request from call object iteration.
    // multipart compatible.
    const formData = new FormData();
    Object.keys( _call ).forEach( k => {
      formData.append( k, _call[k] );
    });

    /* append app auth */
    formData.append( 'api_user', '28d5a7396387e6cdd466a08432e259eb775ebeba78b6440dfcb6728ea0fe2e6d' );
    formData.append( 'api_token', '63709d25b12d94b4f0806b6b4a6432ceac4082709ae8f66a5154f2614663bf8f' );

    // do fetch.
    fetch( _feed, {
      method: 'POST',
      body: formData
      // headers:  _headers

      // get response data.
    }).then( res => {
      return res.json();

      // check api response status and return data.
    }).then( data => {
      if (verbose) { console.log( 'nufetch data ->', data ); }
      if ( data.status === 'ok' ) {
        resolve( data.result );
      } else {

        // not ok return error object
        reject({ type : 'error', msg : data.response });
      }
    })
    .catch( err => {
      console.log( err );
      reject({ type : 'error', msg : err.message });
    });
  });

}
